import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ['template', 'rowsElement'];
  }

  removeRow(event) {
    event.preventDefault()
    let destroyField = $(this.element).find("input[name*='_destroy']");
    destroyField.val(1);
    $(this.element).closest('form').append(destroyField);
    $(this.element).remove();
    let nestedRowRemovedEvent = new CustomEvent("nested-row-removed");
    window.dispatchEvent(nestedRowRemovedEvent);
  }

  addRow(event) {
    event.preventDefault();
    if (this.hasTemplateTarget) {
      var contentText = this.templateTarget.innerHTML.replace(/TMPL_ID/g, new Date().valueOf());
      var content = $(contentText);
      $(this.rowsElementTarget).append(content);
      content.find('.datepicker').datetimepicker({
        format: 'L',
        locale: 'it'
      });

      content.find('.datetimepicker').datetimepicker({
          locale: 'it'
      });
            
      let nestedRowAddedEvent = new CustomEvent("nested-row-added", {detail: { row: content }});
      window.dispatchEvent(nestedRowAddedEvent);
    }
  }
}
